import { atom } from 'jotai'

export const userAtom = atom({ loggedIn : false, canSee : [""], canEdit : [""], _id : "", person : null})
export const personAtom = atom({})
export const departmentsAtom = atom([])
export const projectsAtom = atom([])
export const teamsAtom = atom([])